import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useMultiStepForm } from "@/hooks";
import { Step2 } from "@/components/FormSteps";
import { DataGrid, type DataGridItem } from "./DataGrid";
import SummaryStep from "./SummaryStep";

export const SummaryStep2: FC = () => {
  const { form } = useMultiStepForm();
  const { t } = useTranslation();

  const data: DataGridItem[] = [
    {
      id: "operator",
      label: t("step2.q1_operator"),
      value: form.getValues().step2.operator?.name ?? "-",
    },
    {
      id: "tariff",
      label: t("step2.q2_tariff"),
      value: form.getValues().step2.tariff?.name ?? "-",
    },
  ];

  return (
    <SummaryStep
      stepTitle="step2"
      stepKey="step2"
      cardTitle={`2. ${t("stepper.step2")}`}
      cardContent={<DataGrid items={data} dataTest="step2-grid" />}
      formComponent={Step2}
    />
  );
};
